<template>
  <div class="lang-selector sticker" ref="LanguageSelector">
    <button
      class="lang-selector-btn cursor-pointer hover:bg-grey-800 flex-shrink-0 inline-flex items-center justify-center h-10 w-10 rounded-lg text-grey-500"
      @click="togglePopup"
      v-tooltip="(!isOpen && {
        content: $t('frontend_sites_side_bar_i18n'),
        placement: 'right',
        classes: ['sidebar-tooltip'],
      })"
    >
      <span class="sr-only">{{ $t('frontend_language_selector_a11y_label') }}</span>
      <component class="w-6" :is="getFlagIcon"/>
    </button>
    <transition
      enter-class="opacity-0"
      leave-to-class="opacity-0"
      enter-active-class="transition-opacity duration-300"
      leave-active-class="transition-opacity duration-300"
      mode="out-in"
    >
      <div class="lang-selector-popup absolute bg-dark z-50 py-2 px-5 rounded-lg" v-if="isOpen">
        <span class="inline-block mb-2 my-1 text-grey-600 text-xs font-bold uppercase">{{ $t('frontend_sites_side_bar_i18n') }}</span>
        <ul class="text-white">
          <li v-for="language in languages" :key="language.value" class="py-2 w-40">
            <button
              class="items-center justify-between py-1 w-full flex"
              :class="{ 'text-pink': locale === language.value }"
              @click="changeLanguage(language)"
            >
              <span>{{ language.label }}</span>
              <CheckIcon class="w-4" v-show="locale === language.value" />
              <component class="w-8" :is="language.icon"/>
            </button>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import I18nIcon from '../assets/i18n.svg'
import CheckIcon from '../assets/check-icon.svg'
import EnFlagIcon from '../assets/en-flag.svg'
import PtFlagIcon from '../assets/pt-flag.svg'
import directives from '../directives';

export default {
  name: 'LanguageSelector',

  directives,

  components: {
    I18nIcon,
    CheckIcon,
    EnFlagIcon,
    PtFlagIcon
  },

  data () {
    return {
      locale: 'en',
      isOpen: false
    }
  },

  computed: {
    getFlagIcon () {
      return this.locale === 'en' ? 'EnFlagIcon' : 'PtFlagIcon'
    },

    languages () {
      return [
        {
          label: this.$t('frontend_sites_side_bar_lang_en'),
          value: 'en',
          icon: 'EnFlagIcon'
        },
        {
          label: this.$t('frontend_sites_side_bar_lang_pt'),
          value: 'pt',
          icon: 'PtFlagIcon'
        }
      ]
    }
  },

  watch: {
    isOpen (val) {
      if (!val) return this.removeEventListeners()
      document.addEventListener('click', this.closeClickOutside)
      document.addEventListener('keydown', this.closeKeydownEsc)
    }
  },

  created () {
    this.locale = localStorage.getItem('lang') || this.locale;
    this.$root.$i18n.locale = this.locale;
    !localStorage.getItem('lang') && localStorage.setItem('lang', this.locale);
  },

  beforeDestroy () {
    this.removeEventListeners()
  },

  methods: {
    changeLanguage (language) {
      this.locale = language.value;
      localStorage.setItem('lang', this.locale);
      window.location.reload();
    },

    togglePopup () {
      this.isOpen = !this.isOpen
      setTimeout(() => this.$refs.LanguageSelector.blur(), 500)
      if (!this.isOpen) return this.$emit('close')
      this.$emit('open')
    },

    closeClickOutside ({ target }) {
      if (!this.$refs.LanguageSelector.contains(target)) this.togglePopup()
    },
    
    closeKeydownEsc ({ which }) {
      if (which === 27) this.togglePopup()
    },

    removeEventListeners () {
      document.removeEventListener('click', this.closeClickOutside)
      document.removeEventListener('keydown', this.closeKeydownEsc)
    }
  }
}
</script>

<style lang="scss" scoped>
.lang-selector {
  &-popup {
    left: 90px;
    margin-top: -20px;
    transform: translateY(-50%);

    &:after {
      border-left: solid transparent 10px;
      border-right: solid #191d3a 10px;
      border-top: solid transparent 10px;
      border-bottom: solid transparent 10px;
      left: -20px;
      content: " ";
      height: 0;
      top: 50%;
      margin-top: -10px;
      position: absolute;
      width: 0;
    }

    li:not(:last-child) {
      @apply border-b border-grey-700;
    }
  }
}
</style>